import { createContext, useMemo } from "react";
import { useCreateSystemDraftOnLocationSelect } from "@RequestFormV2/hooks/useCreateSystemDraftOnLocationSelect";
import { useOrganisationData } from "@RequestFormV2/sections/Organisation/context/useOrganisationData";
import { useOrganisationHandlers } from "@RequestFormV2/sections/Organisation/context/useOrganisationHandlers";

type OrganisationContextType = ReturnType<typeof useOrganisationData> &
  ReturnType<typeof useOrganisationHandlers>;

const OrganisationContext = createContext<OrganisationContextType | null>(null);

function OrganisationProvider({ children }: { children: React.ReactNode }) {
  const data = useOrganisationData();
  useCreateSystemDraftOnLocationSelect(data.selectedLocation);
  const handlers = useOrganisationHandlers(data.organisationFields);

  const value = useMemo(() => ({ ...data, ...handlers }), [data, handlers]);

  return <OrganisationContext.Provider value={value}>{children}</OrganisationContext.Provider>;
}

export { OrganisationContext, OrganisationProvider };
